import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSuperAdmin } from "../context/SuperAdminContext";
import FactorykaOnDemand from '../assets/Factrika-OD.svg';
import ErrorModal from "./ErrorModal";

const SuperAdminLogin = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { sendOtp, verifyOtp, loading, isLoggedIn, isTablet } = useSuperAdmin();

  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [showOtp, setShowOtp] = useState(false);
  const [error, setError] = useState("");
  const [showError, setShowError] = useState(false);

  // The redirect URL is passed as ?redirect=... from HRActionPage
  const redirectTo = searchParams.get('redirect') || '/lkart/superadmin/view';

  useEffect(() => {
    const storedToken = localStorage.getItem('superadmintoken');
    if (storedToken) {
      navigate(isTablet ? "/lkart/admin/tablet-scanner" : redirectTo, { replace: true });
    }
  }, [isLoggedIn, isTablet, navigate, redirectTo]);

  const handleSendOtp = async () => {
    if (phone.length !== 10) return;
    try {
      const res = await sendOtp(phone);
      if(res.success == true)
      {
        setShowOtp(true);  
      }
      else
      {
      setError(res.message);
      setShowError(true);
      }
    } catch {
      setError("You are not registered with us.");
      setShowError(true);
    }{}
  };

  const handleVerifyOtp = async () => {
    if (otp.length !== 4) return;
    try {
      const data = await verifyOtp(phone, otp);
      if (data?.token) {
        const tabletFlag = data.isTablet ?? false;
        navigate(tabletFlag ? "/lkart/admin/tablet-scanner" : redirectTo, { replace: true });
      } else {
        setError(data?.message || "Invalid OTP. Please try again.");
        setShowError(true);
      }
    } catch (err) {
      console.error("OTP verification error:", err);
      setError("Invalid OTP. Please try again.");
      setShowError(true);
    }
  };

  const handlePhoneKeyPress = (e) => {
    if (e.key === "Enter" && phone.length === 10 && !loading) handleSendOtp();
  };

  const handleOtpKeyPress = (e) => {
    if (e.key === "Enter" && otp.length === 4 && !loading) handleVerifyOtp();
  };

  return (
    <>
      <div className="min-h-screen overflow-y-auto pt-16 flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full space-y-8 p-8 bg-white rounded-xl shadow-lg">
          <div className="text-center flex flex-col items-center justify-center">
            <img
              src={FactorykaOnDemand}
              alt="factrika on demand"
              width={180}
              height={180}
              className="object-contain"
            />
            <h2 className="mt-6 text-3xl font-bold text-gray-900">
              Welcome Admin
            </h2>
          </div>

          <div className="mt-8 space-y-6">
            {!showOtp ? (
              <div>
                <input
                  type="tel"
                  maxLength={10}
                  value={phone}
                  onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))}
                  onKeyPress={handlePhoneKeyPress}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
                  placeholder="Enter phone number"
                />
                <button
                  onClick={handleSendOtp}
                  disabled={phone.length !== 10 || loading}
                  className="mt-4 w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50"
                >
                  {loading ? "Sending..." : "Send OTP"}
                </button>
              </div>
            ) : (
              <div>
                <input
                  type="text"
                  maxLength={6}
                  value={otp}
                  onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
                  onKeyPress={handleOtpKeyPress}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
                  placeholder="Enter OTP"
                />
                <button
                  onClick={handleVerifyOtp}
                  disabled={otp.length !== 4 || loading}
                  className="mt-4 w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50"
                >
                  {loading ? "Verifying..." : "Verify OTP"}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <ErrorModal message={error} isOpen={showError} setIsOpen={setShowError} />
    </>
  );
};

export default SuperAdminLogin;